import React from "react";
import LoadingState from "../States/LoadingState";
import MessageBubble from "../Chat/MessageBubble";
import { formatDateSeparator, initials } from "../../utils/consultationChatFormat";

const ChatMessageThread = ({
  displayMessages,
  loading,
  staffId,
  peerName,
  messagesEndRef,
  chatDisabled,
}) => (
  <div className="flex-1 overflow-y-auto p-4 bg-surface-low space-y-3 min-h-0" role="log" aria-live="polite">
    {loading ? (
      <LoadingState size="sm" message="Loading chat…" className="py-8" />
    ) : chatDisabled ? (
      <div className="text-center py-8 px-4">
        <p className="text-on-surface-variant text-sm">Select a conversation to start chatting.</p>
      </div>
    ) : (
      <>
        <div className="flex justify-center sticky top-0 z-[1] pb-2">
          <span className="text-xs bg-surface-container/90 text-on-surface-variant px-3 py-1 rounded-full shadow-sm">
            {formatDateSeparator(displayMessages.find((m) => m.timestamp)?.timestamp || new Date())}
          </span>
        </div>
        {displayMessages.map((msg, index) => (
          <MessageBubble
            key={msg._id || `${msg.timestamp}-${index}`}
            msg={msg}
            isOutgoing={msg.senderId === staffId}
            peerInitial={initials(peerName)}
            staffId={staffId}
          />
        ))}
        <div ref={messagesEndRef} />
      </>
    )}
  </div>
);

export default ChatMessageThread;
